import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { getSubscriptions } from "../../../apis/subscriptionsApis";
import Filtersubscriptions from "./filterSubscriptions";
import { useNavigate } from "react-router-dom/dist";

const Subscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async (searchData={}) => {
    try {
      const res = await getSubscriptions(searchData);
      console.log(res.result)
       if (Array.isArray(res.result)) setSubscriptions(res.result);
      else setSubscriptions([]);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      setLoading(false);
    }
  };
  const currencyConverter = (val) => {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'EUR' }).format(
      val,
    )
  }  

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "5%",
    },
    {
      title: "Name",
      render: (text, record) => (
        <span>
          {record.subSubscribers[0].subscribers?.title
            ? `${record.subSubscribers[0].subscribers.title} ${record.subSubscribers[0].subscribers.firstName || ""} ${record.subSubscribers[0].subscribers.lastName || ""}`
            : ""}
        </span>
      ),
      // sorter: (a, b) => {
      //   const nameA = `${a.subscribers?.[0]?.title || ""} ${a.subscribers?.[0]?.firstName || ""} ${a.subscribers?.[0]?.lastName || ""}`.toLowerCase();
      //   const nameB = `${b.subscribers?.[0]?.title || ""} ${b.subscribers?.[0]?.firstName || ""} ${b.subscribers?.[0]?.lastName || ""}`.toLowerCase();
      //   // return nameA.localeCompare(nameB);
      //   return nameA.localeCompare(nameB);
      // },
      sorter: (a, b) => {
        const subscriberA = a.subSubscribers?.[0]?.subscribers;
        const subscriberB = b.subSubscribers?.[0]?.subscribers;
        const nameA = subscriberA 
          ? `${subscriberA.title || ""} ${subscriberA.firstName || ""} ${subscriberA.lastName || ""}`.toLowerCase() 
          : "";
        const nameB = subscriberB 
          ? `${subscriberB.title || ""} ${subscriberB.firstName || ""} ${subscriberB.lastName || ""}`.toLowerCase() 
          : "";
        return nameA.localeCompare(nameB);
      },
      width: "10%",
    },
    {
      title: "Advisor",
      dataIndex: "introducerId",
      width: "10%",
    },
    {
      title: "Amount",
      render: (text, record) => (
        <span>
          {currencyConverter(record.investmentAmount)}
        </span>
      ),
      width: "10%",
    },
    {
      title: "ShareClass",
      dataIndex: "shareClassType",
      width: "10%",
    },
    // {
    //     title: "Date",
    //     render: (text, record) => (
    //         <span>
    //           {record.createdAt.split("T")[0]}
    //         </span>
    //       ),
    //     width: "10%",
    //   },
      {
        title: "More Details",
        render: (text, record) => (
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/subscriptionDetails/${record.id}`)}
          >
            View
          </button>
        ),
        width: "10%",
      },
  ];


  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
          <div className=" mb-3 p-3 bg-body rounded shadow-sm">
            <Filtersubscriptions onSearch={fetchSubscriptions}/>
            </div>
            {loading ? (
            <div>Loading...</div>
          ) : subscriptions.length === 0 ? (
            <div className="text-center mt-6">
              <p className="text-center">No Subscriptions Are Found</p>
            </div>
            ) : (
              <Table
                columns={columns}
                dataSource={subscriptions}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscriptions;
